export default theme => ({
  container: {
    display: 'flex'
  },
  gridScreenshots: {
    display: 'grid',
    gridGap: 10,
    gridTemplateColumns: 'repeat(3, 1fr)'
  },
  options: {
    height: 30
  },
  optionLabel: {
    fontSize: '0.65rem',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    width: 245
  },
  optionLabelSelected: {
    fontSize: '0.75rem',
    fontWeight: 600,
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    width: 245
  },
  filter: {
    width: 280,
    height: '100vh',
    padding: '0 0 0 15px'
  },
  screenshots: {
    width: '100%',
    boxShadow: 'inset 1px 0px 0px 0px #DDD'
  },
  header: {
    paddingTop: 30,
    paddingLeft: 30,
    paddingRight: 30,
    borderBottom: '1px solid ' + theme.palette.divider
  },
  box: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer'
  },
  selectedCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#e2ece6',
    border: '2px solid ' + theme.palette.secondary.main,
    cursor: 'pointer'
  },
  media: {
    padding: 5,
    width: '95%',
    '& svg': {
      color: theme.palette.secondary.main
    },
    '& img': {
      borderRadius: 5,
      width: 'auto !important',
      height: '12rem !important',
      position: 'unset !important',
      maxWidth: 'calc(100%) !important'
    },
    '& div': {
      padding: 'calc(1%) !important',
      textAlign: 'center'
    }
  },
  cardText: {
    fontSize: '0.75rem',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  },
  download: {
    cursor: 'pointer',
    margin: '0 10px'
  },
  selectLabels: {
    fontSize: '0.75rem',
    cursor: 'pointer',
    margin: '0 10px'
  },
  noData: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center'
  },
  checkbox: {
    color: '#555555a6'
  }
});
